import React, { useState } from "react";
import styled from "styled-components";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const CarouselInner = styled.div<{ index: number }>`
  display: flex;
  transform: translateX(${(props) => -props.index * 100}%);
  transition: transform 0.5s ease-in-out;
  width: 100%;
`;

const CarouselIndicators = styled.ol`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  list-style: none;
  padding: 0;
`;

const Indicator = styled.li<{ $active: boolean }>`
  width: 10px;
  height: 10px;
  margin: 0 5px;
  background-color: ${(props) => (props.$active ? "#333" : "#ccc")};
  border-radius: 50%;
  cursor: pointer;
`;

const Item = styled.div`
  min-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const ImageContainer = styled.div`
  max-width: 500px;
  max-height: 400px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

const ArrowContainer = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 24px;
  z-index: 10;

  &:hover {
    color: gray;
  }
`;

const LeftArrow = styled(ArrowContainer)`
  left: 10px;
`;

const RightArrow = styled(ArrowContainer)`
  right: 10px;
`;

interface Props {
  content: React.ReactNode[];
}

const Caroussel: React.FC<Props> = ({ content }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? content.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === content.length - 1 ? 0 : prev + 1));
  };

  return (
    <Wrapper>
      <CarouselInner index={currentIndex} data-testid="carousel-container">
        {content.map((item, index) => (
          <Item key={index}>
            {content.length > 1 && (
              <LeftArrow onClick={prevSlide}>
                <MdArrowBackIosNew />
              </LeftArrow>
            )}
            <ImageContainer>{item}</ImageContainer>
            {content.length > 1 && (
              <RightArrow onClick={nextSlide}>
                <MdArrowForwardIos />
              </RightArrow>
            )}
          </Item>
        ))}
      </CarouselInner>

      {content.length > 1 && (
        <CarouselIndicators data-testid="carousel-indicators">
          {content.map((_, index) => (
            <Indicator
              data-testid="indicator"
              key={index}
              $active={index === currentIndex}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </CarouselIndicators>
      )}
    </Wrapper>
  );
};

export default Caroussel;
